import * as React from 'react';

import { useQuery } from '@apollo/client';

import { useParams } from 'js/lib/useRouter';

import DegreeDescriptionPersonalizationContext from 'bundles/degree-description/contexts/DegreeDescriptionPersonalizationContext';
import type {
  GetPersonalizedDdpBySlugQuery,
  GetPersonalizedDdpBySlugQueryVariables,
} from 'bundles/degree-description/queries/__generated__/getPersonalizedDdpBySlug';
import getPersonalizedDdpBySlug from 'bundles/degree-description/queries/getPersonalizedDdpBySlug.graphql';

export const DegreeDescriptionPagePersonalizationProvider: React.LegacyFunctionComponentWithChildren = ({
  children,
}) => {
  const { slug } = useParams();

  const { data } = useQuery<GetPersonalizedDdpBySlugQuery, GetPersonalizedDdpBySlugQueryVariables>(
    getPersonalizedDdpBySlug,
    {
      skip: !slug,
      variables: {
        // @ts-expect-error TS2769 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
        degreeSlug: slug,
      },
      context: { clientName: 'gatewayGql' },
    }
  );

  const queryData = {
    personalizedDdpData: data?.PersonalizedDdp?.queryPersonalizedDdpData,
  };

  return (
    <DegreeDescriptionPersonalizationContext.Provider value={queryData}>
      {children}
    </DegreeDescriptionPersonalizationContext.Provider>
  );
};
